import { Button } from '@/components/Button';
import { Modal } from '@/components/Modal';
import { useAuthStore } from '@/stores/useAuthStore';
import { useTranslation } from 'react-i18next';

export const RGPDModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const { acceptRGPD } = useAuthStore();
  const handleAccept = async () => {
    await acceptRGPD();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="w-full max-w-md"
      disableCloseOnClickOutside
    >
      <div className="flex flex-col gap-4">
        <h1 className="text-2xl font-bold">{t('rgpdModal:title')}</h1>
        <p
          className="text-sm text-gray-600"
          dangerouslySetInnerHTML={{
            __html: t('rgpdModal:description'),
          }}
        />
      </div>
      <div className="flex justify-end">
        <Button onClick={handleAccept}>{t('rgpdModal:accept')}</Button>
      </div>
    </Modal>
  );
};
